import { ITipo_Campo } from "../helpers/IFormHelper";
import { shortDate } from "../helpers/dateHelper";
interface IRenderTitle {
  value: any;
  type?: number;
}
const RenderValue = ({ value, type }: IRenderTitle) => {
  if (type === ITipo_Campo.user || type === ITipo_Campo.multiuser) {
    return <i>{value[`${value.ID}_DISPLAY`]}</i>;
  } else if (type === ITipo_Campo.date) {
    return <i>{shortDate(value)}</i>;
  } else {
    return <i>{value}</i>;
  }
};

export default RenderValue;
